import { type PaperProps } from '@pets-ui/Paper/Paper'
import { Paper } from '@pets-ui/Paper/Paper'

export type CartCardProps = PaperProps

export const CartCard = (props: CartCardProps) => {
  return (
    <Paper display="flex" flexDirection="column" elevation={0} borderRadius={8} position="relative" {...props} />
  )
}
